import React, { useState } from "react";
import { fmtBRL } from "@/lib/supabase";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from
"@/components/ui/select";
import { toast } from "sonner";
import { Calculator } from "lucide-react";

export default function CalculatorPage() {
  const [form, setForm] = useState({
    work_type: "tcc",
    measure_type: "palavras",
    word_count: 15000,
    lauda_size: "2100",
    complexity: "intermediaria",
    deadline_days: 10,
    service_level: "revisao_completa",
    num_images: 0,
    has_graphic_project: false
  });
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const calc = async () => {
    setLoading(true);
    const BASE = { tcc: 0.035, artigo: 0.040, dissertacao: 0.045, tese: 0.055, livro: 0.050, ebook: 0.035, outro: 0.035 };
    const BASE_PAGE = { tcc: 15, artigo: 18, dissertacao: 20, tese: 25, livro: 12, ebook: 10, outro: 15 };
    const CMULT = { basica: 1.0, intermediaria: 1.30, avancada: 1.70 };
    const SMULT = {
      revisao_ortografica: 1.0,
      revisao_gramatical: 1.25,
      revisao_completa: 1.60,
      copidesque: 2.10,
      diagramacao: 1.0,
      revisao_diagramacao: 1.60
    };

    const input_amount = Number(form.word_count);
    const dd = Number(form.deadline_days);
    const urgency = dd <= 2 ? 2.0 : dd <= 5 ? 1.5 : dd <= 10 ? 1.2 : 1.0;

    let suggested = 0;
    let wc = 0;
    let ppw = 0;
    let hours = 0;

    // Se  Diagramao exclusiva
    const isDiagramacaoOnly = form.service_level === "diagramacao";
    const isCombo = form.service_level === "revisao_diagramacao";

    if (form.measure_type === "paginas") {
      // Se for apenas revisão e escolheu pginas (incomum, mas convertemos)
      // Vamos assumir que 1 pgina = 300 palavras para revisão
      if (!isDiagramacaoOnly && !isCombo) {
        wc = input_amount * 300;
        ppw = BASE[form.work_type] * CMULT[form.complexity] * SMULT[form.service_level] * urgency;
        suggested = ppw * wc;
        hours = Math.round(wc / 800 / (SMULT[form.service_level] * 0.75) * 10) / 10;
      } else {
        // Diagramao (exclusiva ou combo)
        const base_p = BASE_PAGE[form.work_type] || 15;
        let calcDiag = base_p * input_amount * CMULT[form.complexity] * urgency;

        if (isCombo) {
          // Combina o valor da diagramao + revisão por estimativa de palavras (300/pag)
          wc = input_amount * 300;
          ppw = BASE[form.work_type] * CMULT[form.complexity] * SMULT["revisao_completa"] * urgency;
          let calcRev = ppw * wc;
          suggested = calcRev + calcDiag;
          hours = Math.round(input_amount * 0.4 + wc / 800 / (SMULT["revisao_completa"] * 0.75));
        } else {
          suggested = calcDiag;
          hours = Math.round(input_amount * 0.4 * 10) / 10;
        }
      }
    } else {
      // Clculo por Palavras/Laudas
      wc = form.measure_type === "caracteres" ? Math.round(input_amount / 6) : input_amount;

      if (isDiagramacaoOnly) {
        // Se escolheu diagramao mas a medida est em palavras
        // Converte palavras para pginas (estimativa 300 palavras/pag)
        const estimativaPaginas = Math.ceil(wc / 300);
        const base_p = BASE_PAGE[form.work_type] || 15;
        suggested = base_p * estimativaPaginas * CMULT[form.complexity] * urgency;
        hours = Math.round(estimativaPaginas * 0.4 * 10) / 10;
      } else {
        ppw = BASE[form.work_type] * CMULT[form.complexity] * SMULT[form.service_level] * urgency;
        suggested = ppw * wc;
        hours = Math.round(wc / 800 / (SMULT[form.service_level] * 0.75) * 10) / 10;

        if (isCombo) {
          // Adiciona diagramao por estimativa de pginas
          const estimativaPaginas = Math.ceil(wc / 300);
          const base_p = BASE_PAGE[form.work_type] || 15;
          let calcDiag = base_p * estimativaPaginas * CMULT[form.complexity] * urgency;
          suggested += calcDiag;
          hours += Math.round(estimativaPaginas * 0.4 * 10) / 10;
        }
      }
    }

    // Adicionais de imagens/tabelas e Projeto Grfico (Apenas se tiver Diagramao)
    if (isDiagramacaoOnly || isCombo || form.measure_type === "paginas") {
      suggested += Number(form.num_images) * 8;
      if (form.has_graphic_project) {
        const gp_fee = form.work_type === "livro" || form.work_type === "tese" ? 450 : 250;
        suggested += gp_fee;
      }
    }

    suggested = Math.round(suggested * 100) / 100;

    let total_laudas = null;
    let price_per_lauda = null;
    if (form.measure_type === "caracteres") {
      total_laudas = Math.round(input_amount / Number(form.lauda_size) * 10) / 10;
      price_per_lauda = total_laudas > 0 ? Math.round(suggested / total_laudas * 100) / 100 : 0;
    }

    setResult({
      suggested_price: suggested,
      minimum_price: Math.round(suggested * 0.75 * 100) / 100,
      premium_price: Math.round(suggested * 1.35 * 100) / 100,
      price_per_word: ppw ? Math.round(ppw * 10000) / 10000 : 0,
      estimated_hours: hours,
      total_laudas,
      price_per_lauda,
      breakdown: { hour_rate: hours ? Math.round(suggested / hours * 100) / 100 : suggested },
      input: { ...form }
    });
    toast.success("Preo calculado!");
    setLoading(false);
  };

  const showVisualElements = form.measure_type === "paginas" || form.service_level.includes("diagramacao");

  return (
    <div data-testid="calculator-page">
      <div className="mb-8">
        <div className="font-mono text-xs uppercase tracking-widest text-[#D9381E] mb-2">Precificao</div>
        <h1 className="font-serif text-4xl md:text-5xl">Calculadora Inteligente</h1>
        <p className="text-[#4A4A4A] mt-2">Precifique com base em escopo real  nunca mais chute valores.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <Card className="p-8 bg-white border border-black/10 rounded-none">
          <div className="space-y-5">
            <div>
              <Label className="text-xs font-mono uppercase tracking-widest mb-2 block">Tipo de trabalho</Label>
              <Select value={form.work_type} onValueChange={(v) => update("work_type", v)}>
                <SelectTrigger className="rounded-none" data-testid="calc-work-type"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="tcc">TCC / Monografia</SelectItem>
                  <SelectItem value="artigo">Artigo cientfico</SelectItem>
                  <SelectItem value="dissertacao">Dissertao</SelectItem>
                  <SelectItem value="tese">Tese</SelectItem>
                  <SelectItem value="livro">Livro</SelectItem>
                  <SelectItem value="ebook">E-book</SelectItem>
                  <SelectItem value="outro">Outro</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-xs font-mono uppercase tracking-widest mb-2 block">Nvel de servio / Edio</Label>
              <Select value={form.service_level} onValueChange={(v) => update("service_level", v)}>
                <SelectTrigger className="rounded-none" data-testid="calc-service"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="revisao_ortografica">Reviso Ortogrfica</SelectItem>
                  <SelectItem value="revisao_gramatical">Reviso Gramatical</SelectItem>
                  <SelectItem value="revisao_completa">Reviso Completa</SelectItem>
                  <SelectItem value="copidesque">Copidesque</SelectItem>
                  <SelectItem value="diagramacao">Diagramao / Layout</SelectItem>
                  <SelectItem value="revisao_diagramacao">Combo: Reviso + Diagramao</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-xs font-mono uppercase tracking-widest mb-2 block">Forma de contagem</Label>
              <Select value={form.measure_type} onValueChange={(v) => update("measure_type", v)}>
                <SelectTrigger className="rounded-none"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="palavras">Por Palavras</SelectItem>
                  <SelectItem value="caracteres">Por Caracteres (Lauda)</SelectItem>
                  <SelectItem value="paginas">Por Pginas (Diagramao)</SelectItem>
                </SelectContent>
              </Select>
            </div>
            {form.measure_type === "caracteres" &&
            <div>
                <Label className="text-xs font-mono uppercase tracking-widest mb-2 block">Tamanho da Lauda</Label>
                <Select value={form.lauda_size} onValueChange={(v) => update("lauda_size", v)}>
                  <SelectTrigger className="rounded-none"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="1400">1.400 caracteres com espao</SelectItem>
                    <SelectItem value="1800">1.800 caracteres com espao</SelectItem>
                    <SelectItem value="2100">2.100 caracteres com espao</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            }
            <div>
              <Label className="text-xs font-mono uppercase tracking-widest mb-2 block">
                {form.measure_type === "caracteres" ? "Quantidade de Caracteres" :
                form.measure_type === "paginas" ? "Quantidade de Pginas" : "Quantidade de Palavras"}
              </Label>
              <Input type="number" value={form.word_count} onChange={(e) => update("word_count", e.target.value)}
              className="rounded-none" data-testid="calc-words" />
            </div>
            <div>
              <Label className="text-xs font-mono uppercase tracking-widest mb-2 block">Complexidade</Label>
              <Select value={form.complexity} onValueChange={(v) => update("complexity", v)}>
                <SelectTrigger className="rounded-none" data-testid="calc-complexity"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="basica">Bsica</SelectItem>
                  <SelectItem value="intermediaria">Intermediria</SelectItem>
                  <SelectItem value="avancada">Avanada (tcnica)</SelectItem>
                </SelectContent>
              </Select>
            </div>

            {showVisualElements &&
            <div className="space-y-4 border-l-2 border-[#D9381E] pl-4 py-2 bg-slate-50">
                <div>
                  <Label className="text-xs font-mono uppercase tracking-widest mb-2 block">Elementos Visuais (Imagens/Tabelas)</Label>
                  <Input type="number" value={form.num_images} onChange={(e) => update("num_images", e.target.value)} className="rounded-none bg-white" />
                  <p className="text-[10px] text-muted-foreground mt-1">Quantidade de imagens, grficos ou tabelas que exigem ajuste.</p>
                </div>
                <div className="flex items-center space-x-2">
                  <input
                  type="checkbox"
                  id="graphic_project"
                  checked={form.has_graphic_project}
                  onChange={(e) => update("has_graphic_project", e.target.checked)}
                  className="w-4 h-4 accent-[#D9381E]" />
                
                  <Label htmlFor="graphic_project" className="text-xs font-mono uppercase tracking-widest cursor-pointer">Incluir Projeto Grfico</Label>
                </div>
              </div>
            }
            <div>
              <Label className="text-xs font-mono uppercase tracking-widest mb-2 block">Prazo (dias)</Label>
              <Input type="number" value={form.deadline_days} onChange={(e) => update("deadline_days", e.target.value)}
              className="rounded-none" data-testid="calc-deadline" />
            </div>
            <Button onClick={calc} disabled={loading}
            className="w-full rounded-none bg-[#D9381E] hover:bg-[#B82914] text-white py-6"
            data-testid="calc-submit">
              <Calculator className="w-4 h-4 mr-2" />
              {loading ? "Calculando..." : "Calcular preo"}
            </Button>
          </div>
        </Card>

        <Card className="p-8 bg-[#1A1A1A] text-white rounded-none">
          {!result ?
          <div className="h-full flex items-center justify-center text-white/40 font-mono text-sm text-center">
              Preencha os dados e clique em "Calcular".
            </div> :

          <div data-testid="calc-results">
              <div className="font-mono text-xs uppercase tracking-widest text-[#D9381E] mb-6">Sugesto</div>
              <div className="mb-8">
                <div className="text-white/60 text-sm">Preo recomendado</div>
                <div className="font-serif text-6xl" data-testid="calc-suggested">{fmtBRL(result.suggested_price)}</div>
              </div>
              <div className="grid grid-cols-2 gap-6 border-t border-white/10 pt-6">
                <div>
                  <div className="text-white/60 text-xs font-mono uppercase">Mnimo vivel</div>
                  <div className="font-serif text-2xl">{fmtBRL(result.minimum_price)}</div>
                </div>
                <div>
                  <div className="text-white/60 text-xs font-mono uppercase">Premium</div>
                  <div className="font-serif text-2xl">{fmtBRL(result.premium_price)}</div>
                </div>
                {result.price_per_word > 0 &&
              <div>
                    <div className="text-white/60 text-xs font-mono uppercase">Por palavra</div>
                    <div className="font-mono text-lg">R$ {result.price_per_word.toFixed(4)}</div>
                  </div>
              }
                <div>
                  <div className="text-white/60 text-xs font-mono uppercase">Horas estimadas</div>
                  <div className="font-mono text-lg">{result.estimated_hours}h</div>
                </div>
                {result.total_laudas !== null &&
              <>
                    <div>
                      <div className="text-white/60 text-xs font-mono uppercase">Total de Laudas</div>
                      <div className="font-mono text-lg">{result.total_laudas} laudas</div>
                    </div>
                    <div>
                      <div className="text-white/60 text-xs font-mono uppercase">Preo por Lauda</div>
                      <div className="font-mono text-lg">{fmtBRL(result.price_per_lauda)}</div>
                    </div>
                  </>
              }
                <div className="col-span-2">
                  <div className="text-white/60 text-xs font-mono uppercase">Valor/hora</div>
                  <div className="font-mono text-lg">{fmtBRL(result.breakdown.hour_rate)}</div>
                </div>
              </div>
            </div>
          }
        </Card>
      </div>
    </div>);

}